import { Promise } from 'es6-promise';
import Api from '../shared/Api';

class UserApi {
    static getMeDetails(): Promise<any> {
        return new Api().get('/me/details');
    }

    static customers(search: string): Promise<{
        customers: { label: string; value: string; firm: string }[];
    }> {
        let searchTerm = encodeURIComponent(search);
        return new Api().get(`/users/customers?search=${searchTerm}`);
    }
    static sendUserNotFoundForm(
        name: string,
        brokerFirm: string,
        email: string,
        phoneNumber: string,
        organizationNumber: string,
        message: string
    ): Promise<void> {
        return new Api().post('/users/send-user-not-found-form', {
            name,
            brokerFirm,
            email,
            phoneNumber,
            organizationNumber,
            message
        });
    }
}

export default UserApi;
